import React from 'react'
import { Route, useNavigate } from 'react-router-dom';
import { encryptStorage } from 'src/Util';

const ProtectedTrialRoute = ({ children }) => {
    const navigate = useNavigate();
    const trialAuth = sessionStorage.getItem('trial-user-authenticated')
    //console.log(trialAuth,'---trialAuth---', !trialAuth)
    if (!trialAuth) {
        navigate('/trial')
        window.location.href="#/trial"
        window.location.reload()
    }
    return children;
}

export default ProtectedTrialRoute